/**
 * blackmostros lazyload for pronia.
 *
 *
 */

import {
  fetch_style,
  console_if_debug,
  } from './blackmostros.method.js';


let LazyLoad = (function(_uri, $, window){
  var $q = function(q, res){
        if (document.querySelectorAll) {
          res = document.querySelectorAll(q);
        } else {
          var d=document,
             a=d.styleSheets[0] || d.createStyleSheet();
          a.addRule(q,'f:b');
          for(var l=d.all,b=0,c=[],f=l.length;b<f;b++) l[b].currentStyle.f && c.push(l[b]);

          a.removeRule(0);
          res = c;
        }
        return res;
      },
     addEventListener = window.addEventListener,
     // addEventListener = function(evt, fn){
     //    window.addEventListener
     //      ? this.addEventListener(evt, fn, false)
     //      : (window.attachEvent)
     //        ? this.attachEvent('on' + evt, fn)
     //        : this['on' + evt] = fn;
     // },
     // not used
     // _has = function(obj, key) {
     //    return Object.prototype.hasOwnProperty.call(obj, key);
     //  },
     _props = {
      _sprite_path: `${_uri}/images/sprites/`,
      _sprite_ext: '.png',
      _css_sprite_path: `${_uri}/templates/blackmostros1/css/`,
      _css_ext: '.min.css',
      },
     mpublic = {}
    ;

  function loadImage (el, fn) {
    var img = new Image(),
       src = el.getAttribute('data-src');
    img.onload = function() {
      if (el.parent) el.parent.replaceChild(img, el)
      else el.src = src;

      fn? fn() : null;
    }
    img.src = src;
  }

  function elementInViewport(el) {
    var rect = el.getBoundingClientRect()

    return (
       rect.top >= 0
    && rect.left >= 0
    && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    )
  }

  function _splice_image(images, i) {
    images.splice(i, i);
  }

  function _start_lazyload_image_support(){
    var images = new Array(),
       query = $q('img.lazy'),
       processScroll = function(){
          for (var i = 0; i < images.length; i++) {
            if (elementInViewport(images[i])) {
              loadImage(
                images[i],
                _splice_image(images, i)
              );
            }
          }
        };

    // Array.prototype.slice.call is not callable under our lovely IE8
    for (var i = 0; i < query.length; i++) {
      images.push(query[i]);
    }

    processScroll();
    addEventListener('scroll', processScroll);
  }

  /**
   * get image path for logos
   *
   *
   */
  function _get_css_sprite_path(image){
    return `${_props._css_sprite_path}${image}${_props._css_ext}`;
  }

  /*
   * get required logo images to download
   *
   */
  function _get_required_logo_images(){
    let _logos = $.querySelectorAll('div.local.logo'),
    _leagues = [
      'futbol', 'mlb', 'nhl', 'rugby', 'acb', 'nba', 'wnba', 'nfl', 'bandera'],
    _list = {},
    _val;

    for (let parent of _logos){
      for (let logo of parent.children) {
        _val = logo.classList.value;
        for (let league of _leagues){
          // ~ console.log('league', _val, league, _list.indexOf(league));
          if (_val.startsWith(league) && Object.keys(_list).indexOf(league) == -1) {
            _list[league] = logo;
            break;
          }
        }
      }
    }
    return _list;
  }

  function _start_lazyload_css_support(){
    let _ilist = _get_required_logo_images(),
      _rlist = [],
      processScroll = function(){
        for (let logo of Object.keys(_ilist)) {
          if (elementInViewport(_ilist[logo]) && _rlist.indexOf(logo) == -1) {
            fetch_style(_get_css_sprite_path(logo));
            _rlist.push(logo);
          }
        }
      };

    processScroll();
    addEventListener('scroll', processScroll);
    // ~ console.log('css list:', _ilist);
    // for (let image of _ilist){
    //   console.log('logo images:', _get_css_sprite_path(image));
    // }
  }

  function _init(){
    _start_lazyload_image_support();
    _start_lazyload_css_support();
    // ~ console.log(_uri);
    console_if_debug('LazyLoad ready...');
    // ~ console.log('LazyLoad ready...');
  }
  mpublic.init = _init;

  return mpublic;

});

export {
  LazyLoad,
  };
